import { render, staticRenderFns } from "./ModalErrorPermission.vue?vue&type=template&id=1791c896&"
import script from "./ModalErrorPermission.vue?vue&type=script&lang=js&"
export * from "./ModalErrorPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports